import { StoreState } from '@/core/models/store.interface';
import { MyPartnerFilter, OverviewFilter, WatchlistFilter } from '@/core/store/filter.interface';
import { Module } from 'vuex';

export interface FiltersState {
   myOverviewFilters: OverviewFilter | null;
   WatchlistFilters: WatchlistFilter | null;
   MyPartnerFilters: MyPartnerFilter | null;
}

const FiltersStore: Module<FiltersState, StoreState> = {
   namespaced: true,
   state: {
      myOverviewFilters: null,
      WatchlistFilters: null,
      MyPartnerFilters: null,
   },
   getters: {},
   mutations: {
      SET_MY_OVERVIEW_FILTERS(state, filters: OverviewFilter) {
         state.myOverviewFilters = filters;
      },
      SET_WATCHLIST_FILTERS(state, filters: WatchlistFilter) {
         state.WatchlistFilters = filters;
      },
      SET_MY_PARTNER_FILTERS(state, filters: MyPartnerFilter) {
         state.MyPartnerFilters = filters;
      },
   },
   actions: {},
};

export default FiltersStore;
